import { SignupScreen } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { View } from 'react-native';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Button, ButtonSize } from '../../components';
import Theme from '../../theme';
import { TextInput } from '../../ui';
import { defaultScale, isNameValid } from '../../utils';
import { focusOnInput } from '../../utils/FocusOnInput';
import { getNextStep, navigateToNextStep } from '../actions';
import { styles as SharedStyles } from '../SignupFormsStyles';
import { INavigateToNextStep } from '../types';
import { OnboardingScreenHeader } from './OnBordingScreenHeader';

interface IProps {
  navigation: any;
  isLoading: boolean;
  getNextStep: (navigateToNextStep: INavigateToNextStep) => void;
  navigateToNextStep: (navigateToNextStep: any) => void;
  handleSubmit: (fn: (values: INamesFormValues) => void) => () => any;
  t: (key: string, options?: any) => string;
}

interface INamesFormValues {
  firstname: string;
  lastname: string;
}

export class OnBoardingStartUserNames extends PureComponent<IProps> {
  private lastnameInput: any;

  public render() {
    const { t, handleSubmit } = this.props;
    return (
      <View style={SharedStyles.container}>
        <OnboardingScreenHeader header={t('auth:appOnboardingNameHeader')} />

        <Field
          name='firstname'
          autoFocus
          returnKeyType='next'
          autoCapitalize='words'
          placeholder={t('formFields:firstname')}
          height={45}
          component={TextInput}
          validate={isNameValid}
          blurOnSubmit={false}
          onSubmitEditing={() => focusOnInput(this.lastnameInput)}
        />
        <Field
          forwardRef
          name='lastname'
          returnKeyType='done'
          autoCapitalize='words'
          placeholder={t('formFields:lastname')}
          component={TextInput}
          validate={isNameValid}
          height={45}
          ref={(ref) => {
            this.lastnameInput = ref;
          }}
          onSubmitEditing={handleSubmit(this.submit)}
          blurOnSubmit
        />

        <Button
          fontColor={Theme.WHITE}
          size={ButtonSize.MEDIUM}
          containerStyle={{ marginTop: defaultScale(10) }}
          onPress={handleSubmit(this.submit)}
          title={t('auth:next')}
        />
      </View>
    );
  }

  private submit = (values: INamesFormValues) => {
    this.props.getNextStep({
      currentScreen: SignupScreen.UserNames,
      userProfile: {
        firstname: values.firstname,
        lastname: values.lastname,
      },
    });
    this.props.navigateToNextStep(this.props.navigation);
  }
}

const mapDispatchToProps = ({
  getNextStep,
  navigateToNextStep,
});

export default translate(['auth'], { wait: true })(
  reduxForm({ form: 'OnBoardingNames' })(
    connect(null, mapDispatchToProps)(
      OnBoardingStartUserNames,
    ),
  ),
);
